export const retrieveUserToken = (): string | null => {
  return localStorage.getItem("token")
}

export const storeUserToken = (token: string) => {
  localStorage.setItem("token", token)
}

export const removeUserTokenFromSession = () => {
  localStorage.removeItem("token")
}
